import shuttleBoxModal from './shuttleBoxModal.vue'
export default shuttleBoxModal
